var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessagesChatRegular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 9.22417C10.0322 9.22417 10.0575 9.1988 10.0575 9.1675V9.16667C10.0575 9.13491 10.0318 9.10917 10 9.10917C9.96828 9.10917 9.94254 9.13491 9.94254 9.16667C9.94254 9.19842 9.96828 9.22417 10 9.22417H10.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00087 9.22417C7.03217 9.22417 7.05754 9.1988 7.05754 9.1675V9.16667C7.05754 9.13491 7.0318 9.10917 7.00004 9.10917C6.96828 9.10917 6.94254 9.13491 6.94254 9.16667C6.94254 9.19842 6.96828 9.22417 7.00004 9.22417H7.00087",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9175 9.22417C12.9488 9.22417 12.9742 9.1988 12.9742 9.1675V9.16667C12.9742 9.13491 12.9484 9.10917 12.9167 9.10917C12.8849 9.10917 12.8592 9.13491 12.8592 9.16667C12.8592 9.19842 12.8849 9.22417 12.9167 9.22417H12.9175",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78404 2.9165H11.697C12.6073 2.91651 13.4687 3.12614 14.2355 3.49976C16.1683 4.44146 17.5 6.42497 17.5 8.71953V8.77976C17.5 10.3188 16.8886 11.7948 15.8003 12.8831C14.7121 13.9714 13.236 14.5828 11.697 14.5828H10.8442C10.8382 14.5828 10.8333 14.5877 10.8333 14.5937V16.479C10.8333 16.6923 10.7207 16.8898 10.5371 16.9983C10.3535 17.1069 10.1262 17.1104 9.93927 17.0077L5.75572 14.7068C3.74762 13.6023 2.5 11.4923 2.5 9.20055C2.5 7.53392 3.16206 5.93555 4.34055 4.75706C5.51903 3.57857 7.11741 2.9165 8.78404 2.9165Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessagesChatRegular);
export default ForwardRef;